// extracted by mini-css-extract-plugin
export var pageContainer = "_o-1";
export var settingsContent = "_o-0";